import api from "../../../services/api/axios";

export const updateBRECompanyPipelineStage = (
  companyId,
  stage,
  endpoint = "/user-companies",
) =>
  api.patch(`${endpoint}/${companyId}/pipeline-stage`, {
    pipeline_stage: stage === "" ? null : stage,
    pipeline_outcome: null,
  });

export const lookupBRECompanyMatches = ({ companyName, website }) =>
  api.post("/company-lookups", {
    company_name: companyName || null,
    website: website || null,
    company_type: "bre",
  });

export const exportBRECompanies = (endpoint = "/user-companies") =>
  api.get(`${endpoint}/export`, { responseType: "blob" });

export const uploadBRECompanyLeaseDocument = (companyId, file) => {
  const form = new FormData();
  form.append("file", file, file.name);

  return api.post(`/user-companies/${companyId}/lease-document`, form);
};

export const downloadBRECompanyLeaseDocument = (companyId, documentId) =>
  api.get(`/user-companies/${companyId}/lease-documents/${documentId}`, {
    responseType: "blob",
  });

export const deleteBRECompanyLeaseDocument = (companyId, documentId) =>
  api.delete(`/user-companies/${companyId}/lease-documents/${documentId}`);
